import PropTypes from "prop-types";
import R from "ramda";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import { appRoutes } from "routes";
import Presenter from "utils/PropTypesPresenter";
import { getPrimaryTag } from "utils/tagUtils";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    previewVideo: PropTypes.string,
    previewPoster: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    premium: PropTypes.bool,
    thumbnail: PropTypes.string,
    templateGroupType: PropTypes.string,
    defaultMakeMessage: PropTypes.string,
    tags: PropTypes.string,
    relatedTemplateGroups: PropTypes.arrayOf(PropTypes.shape),
    previewPoster169: PropTypes.string,
    ghostThumbnail: PropTypes.string,
  },
  {
    uploadDate(tg) {
      return R.pathOr("", ["createdAt"], tg);
    },
    duration(tg) {
      dayjs.extend(duration);
      const videoDuration = R.pathOr(0, ["duration"], tg);
      return dayjs.duration(videoDuration, "s").toISOString();
    },
    castNumOptions(tg) {
      const castNumOptions = R.pathOr([], ["castNumOptions"], tg);
      const filter = R.pipe(
        R.filter((n) => n !== 0),
        R.sortBy(R.identity),
        R.uniqBy(R.identity),
      );
      return filter(castNumOptions);
    },
    firstCastNum(tg) {
      return this.castNumOptions(tg)[0];
    },
    castsCount(tg) {
      return (
        tg &&
        (sessionStorage.getItem("selectedCastNum") !== null
          ? JSON.parse(sessionStorage.getItem("selectedCastNum"))
          : this.firstCastNum(tg))
      );
    },
    castingCardThumb(tg) {
      const template = this.template(tg);
      const { castingCardThumb } = template;
      return castingCardThumb;
    },
    template(tg) {
      const selectedCastNum = this.castsCount(tg);
      const filtered = R.filter((t) => t.castNum === selectedCastNum, tg.templates);

      if (filtered.length) return filtered[0];

      return this.templates(tg)[0];
    },
    templates(tg) {
      const { templates } = tg;
      const sorted = R.sort((a, b) => a.castNum - b.castNumm, templates);
      return sorted;
    },
    isMultiTemplate(tg) {
      return this.castNumOptions(tg).length > 1;
    },
    isStraightUp(tg) {
      return tg && this.templateGroupType(tg) === "straight_up";
    },
    isStarringYouClip(tg) {
      return this.templateGroupType(tg) === "starring_you_clip";
    },
    isStarringYou(tg) {
      return this.templateGroupType(tg) === "starring_you";
    },
    primaryTag(tg) {
      const tags = this.tags(tg);
      return getPrimaryTag(tags);
    },
    hasTag(tg, tag, secondTag = null) {
      const tags = this.tags(tg)
        .replace(/\s/g, "")
        .split(",");

      if (R.isNil(tags)) return false;

      return tags.find((value) => value.includes(tag) || value.includes(secondTag)) !== undefined;
    },
    viewTemplateUrl(tg) {
      const { protocol, host } = window.location;
      return tg && `${protocol}//${host}${appRoutes.templateGroupPath(tg.id)}`;
    },
    posterUrl(tg) {
      if (this.previewPoster169(tg)) {
        return this.previewPoster169(tg);
      }

      if (this.previewPoster(tg)) {
        return this.previewPoster(tg);
      }

      return this.thumbnail(tg);
    },
  },
);
